<template>
  <div class="adcontainer">
    <md-field>
      <md-input-item
        ref="input0"
        title="姓名"
        v-model="par.name"
        placeholder="收貨人姓名"
      ></md-input-item>
      <md-input-item
        ref="input0"
        title="聯繫電話"
        v-model="par.mobile"
        placeholder="收貨人聯繫電話"
      ></md-input-item>
      <md-input-item
        style="position: relative"
        ref="input0"
        title="地址"
        v-model="par.allname"
        readonly
        placeholder="收貨人地址"
      >
        <div class="input-operator" slot="right" @click="openCityPicker()">
          选择地址
        </div>
      </md-input-item>
      <md-input-item
        ref="input0"
        title="詳細地址"
        v-model="par.address"
        placeholder="街道門牌，樓層房間等資訊"
      ></md-input-item>
      <md-input-item
        ref="input0"
        class="none"
        title="郵遞區號"
        maxlength="6"
        v-model="par.postalCode"
        placeholder="收貨人郵遞區號"
      ></md-input-item>
      <!-- <div
        style="position: absolute;width: 100%;height: 1rem;left: 0;top:2rem;"
        @click="ishow = true"
      ></div> -->
    </md-field>
    <p style="text-align: left;display: flex;align-items: center">
      <span style="margin: 0.2rem;color: #e51c23;font-size: 0.32rem"
        >退貨地址僅限中國大陸地區</span
      >
    </p>
    <div>
      <md-button type="warning" round style="margin-top: 0.2rem" @click="submit"
        >保存</md-button
      >
    </div>
    <!-- <md-tab-picker
      title="請選擇"
      describe="請選擇您所在的收貨人郵遞區號"
      large-radius
      :data="data"
      v-model="ishow"
      :mask-closable="false"
      @select="select"
      @change="handleChange"
    /> -->
    <md-picker
      ref="cityPicker"
      v-model="isPickerShow"
      :data="regionData"
      :cols="3"
      is-cascade
      large-radius
      title="选择省市区/县"
      @confirm="onPickerConfirm(1)"
    ></md-picker>
  </div>
</template>

<script>
import {
  InputItem,
  Field,
  CellItem,
  Picker,
  Toast,
  Button,
  TabPicker
} from "mand-mobile";
import regionData from "@/until/district";

export default {
  name: "address",
  components: {
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [Picker.name]: Picker,
    [Button.name]: Button,
    [TabPicker.name]: TabPicker
  },
  data() {
    return {
      ishow: false,
      data: {},
      ieminde: 0,
      par: {
        address: "",
        mobile: "",
        name: "",
        postalCode: "",
        allname: "",
        provinceName: "",
        cityName: "",
        areaName: ""
      },
      // 省市区
      isPickerShow: false,
      regionData
    };
  },
  mounted() {
    // this.district();
    console.log(this.regionData)
  },
  methods: {
    openCityPicker() {
      this.isPickerShow = true;
    },
    onPickerConfirm() {
      const values = this.$refs[`cityPicker`].getColumnValues();
      let res = "";
      values.forEach(value => {
        value && (res += `${value.text || value.label} `);
      });
      console.log(values);
      // this[`pickerValue${index}`] = res
      this.par.provinceName = values[0].label;
      this.par.cityName = values[1] ? values[1].label : "";
      this.par.areaName = values[2] ? values[2].label : "";
      this.par.allname = res;
    },
    district() {
      const par = {
        parentId: 156,
        name: ""
      };
      this.http.APIASK(this.ports.districtsearch, "get", par).then(res => {
        const result = res.map(function(item) {
          return {
            label: item.name,
            value: item.id,
            children: {
              name: "block",
              label: "请选择",
              options: [
                {
                  value: "",
                  label: "请选择",
                  children: {
                    name: "block",
                    label: "请选择",
                    options: [
                      {
                        value: "",
                        label: "请选择",
                        children: {
                          name: "block",
                          label: "请选择",
                          options: []
                        }
                      }
                    ]
                  }
                }
              ]
            }
          };
        });
        this.data = {
          name: "province",
          label: "请选择",
          options: result
        };
        this.pushitmelist(res[0].id, 0);
      });
    },
    pushitmelist(id, index) {
      const par = {
        parentId: id,
        name: ""
      };
      this.http.APIASK(this.ports.districtsearch, "get", par).then(res => {
        const result = res.map(function(item) {
          // tslint:disable-next-line:radix
          return {
            label: item.name,
            value: item.id,
            children: {
              name: "blocks",
              label: "请选择",
              options: []
            }
          };
        });
        this.data.options[index].children.options = result;
        Toast.hide();
      });
    },
    pushitmelistother(id, index) {
      const par = {
        parentId: id,
        name: ""
      };
      this.http.APIASK(this.ports.districtsearch, "get", par).then(res => {
        const result = res.map(function(item) {
          // tslint:disable-next-line:radix
          return {
            label: item.name,
            value: item.id,
            children: { name: "", label: "请选择", options: [] }
          };
        });
        console.log(this.data.options[this.ieminde]);
        console.log(result);
        this.data.options[this.ieminde].children.options[
          index
        ].children.options = result;
        Toast.hide();
      });
    },
    handleChange({ options }) {
      var name = options[0].label + options[1].label + options[2].label;
      Toast.hide();
      if (name.indexOf("台湾") != -1) {
        Toast.failed("港澳台暂不支持退货!");
      } else if (name.indexOf("香港") != -1) {
        Toast.failed("港澳台暂不支持退货!");
      } else if (name.indexOf("澳门") != -1) {
        Toast.failed("港澳台暂不支持退货!");
      } else {
        this.par.provinceName = options[0].label;
        this.par.cityName = options[1].label;
        this.par.areaName = options[2].label;
        this.par.allname = name;
      }
    },
    select(data) {
      Toast.loading("加载中...");
      if (data.index == 0) {
        const ieminde = this.data.options.findIndex(val => {
          return val.value == data.value;
        });
        this.ieminde = ieminde;
        this.pushitmelist(data.value, ieminde);
      } else if (data.index == 1) {
        const ieminde = this.data.options[
          this.ieminde
        ].children.options.findIndex(val => {
          return val.value == data.value;
        });
        this.pushitmelistother(data.value, ieminde);
      }
    },
    submit() {
      if (!this.par.name) {
        Toast.failed("請輸入收貨人姓名!");
        return;
      }
      if (!this.par.mobile) {
        Toast.failed("請輸入收貨人聯繫電話!");
        return;
      }
      if (!this.par.allname) {
        Toast.failed("請選擇收貨人地址!");
        return;
      }
      if (!this.par.address) {
        Toast.failed("請輸入收貨人詳細地址!");
        return;
      }
      const reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
      if (reg.test(this.par.postalCode)) {
        Toast.failed("郵遞區號不能包含中文!");
        return;
      }

      this.$router.push({
        name: "ReturnOrder",
        query: {
          des: this.$route.query.des,
          addres: JSON.stringify(this.par)
        }
      });
    }
  }
};
</script>

<style lang="less">
.adcontainer {
  .md-field {
    padding: 0 0.4rem;
  }

  .md-tab-bar {
    margin-bottom: 1rem;
    margin-top: -1rem;
  }

  .md-field-item-title:before {
    content: "*";
    color: #e51c23;
    margin-right: 0.1rem;
    font-size: 0.5rem;
    margin-top: 0.2rem;
  }

  .md-field-item.none .md-field-item-title:before {
    content: "";
  }

  .md-cell-item-title {
    text-align: left;
  }

  .md-field-item.is-solid .md-field-item-title {
    width: 2rem !important;
    display: flex;
    align-items: center;
  }
}
</style>
